function checkmark(status) {
    return !!status ? `<i class="material-icons" style="font-size: 1.25em">check</i>` : ''
}

export default {
  checkmark,
};
